// \this icon file upload changes
import React from 'react';
import { InformationCircle } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/info-error.css';

const InfoIconWorkinfoRemedy = React.memo(() => (
  <div className="section-info-wrapper summary-info-wrapper">
    <div className="section-info">
      <div className="info-svg-wrapper">
        <div className="info-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="info-message">
        <p>
          <b>
            DO NOT UPLOAD FILES
            {' < '}
            3.5MB IN REMEDY
          </b>
        </p>
      </div>
    </div>
  </div>
));

export {
  InfoIconWorkinfoRemedy,
};
